const section9Data = [
  {
    id: 1,
    question: 'What is APOLO P2P?',
    answer:
      'APOLO P2P is an innovative platform designed to connect students with expert tutors in cryptocurrency, blockchain, and more. Our goal is to make learning accessible and engaging. Whether you’re a beginner or looking to deepen your knowledge, we have the right tutor for you.',
  },
  {
    id: 2,
    question: 'How to sign up?',
    answer:
      "Signing up is simple! Just visit our website, click on the 'Become a Tutor or Student' button, and fill out the required information. You'll be ready to explore our tutoring services in no time.",
  },
  {
    id: 3,
    question: 'What subjects are offered?',
    answer:
      'We offer a wide range of subjects including cryptocurrency, NFTs, blockchain technology, DeFi, and smart contracts. Our tutors are experts in these fields and are ready to help you succeed.',
  },
  {
    id: 4,
    question: 'Are tutors qualified?',
    answer:
      'Absolutely! All our tutors are vetted professionals with extensive knowledge and experience in their respective fields. They are passionate about teaching and committed to helping you achieve your goals.',
  },
  {
    id: 5,
    question: 'How do sessions work?',
    answer:
      'Sessions are conducted online, allowing you to learn from the comfort of your home. You can schedule sessions at your convenience, and our tutors will guide you through the learning process.',
  },
]

export default section9Data
